import { useAppTranslation } from "@/utils";
import { Link } from "react-router-dom";
import { Flex, Menu, Typography, usePaypingContext } from "@payping/web-components";
import { FeatherLeft, PhRFileCode, PhRPlugs, PhRTreeStructure } from "@payping/icons";
import { DashboardRoutes } from "@/router";
import { useSelectedTab } from "./useSelectedTab";

const ConnectionsMenu = () => {
  const { t } = useAppTranslation();
  const { breakpoints } = usePaypingContext();
  const { lg } = breakpoints;
  const selectedTab = useSelectedTab();

  // Menu items for both desktop and mobile
  const menuItems = [
    {
      key: DashboardRoutes.connections.plugins.root.url,
      icon: <PhRPlugs />,
      label: <Link to={DashboardRoutes.connections.plugins.root.url}>{t("connections.mobileMenu.plugins")}</Link>,
    },
    {
      key: DashboardRoutes.connections.developers.root.url,
      icon: <PhRFileCode />,
      label: <Link to={DashboardRoutes.connections.developers.root.url}>{t("connections.mobileMenu.developers")}</Link>,
    },
    {
      key: DashboardRoutes.connections.oauth.root.url,
      icon: <PhRTreeStructure />,
      label: <Link to={DashboardRoutes.connections.oauth.root.url}>{t("connections.mobileMenu.oauth")}</Link>,
    },
  ];

  const desktopMenu = (
    <Flex vertical className={"tw:h-full!"}>
      {/* < تایتل "اتصالات" > */}
      <Typography.Text type={"secondary"}>{t("connections.mobileMenu.title")}</Typography.Text>

      {/* < منو گزینه اتصالات > */}
      <Menu mode="inline" className={"tw:h-full! tw:border-b-0!"} items={menuItems} selectedKeys={[selectedTab]} />
    </Flex>
  );

  const mobileMenu = (
    <Flex vertical className={"tw:p-4! tw:py-12!"}>
      {/* < تایتل "اتصالات" > */}
      <Typography.Title className={"tw:mb-8! font-bold"} level={4}>
        {t("connections.mobileMenu.title")}
      </Typography.Title>

      {/* < منو گزینه اتصالات > */}
      <Menu
        mode="inline"
        className="tw:border-0"
        items={menuItems.map((item) => ({
          ...item,
          label: (
            <div className={"tw:flex tw:justify-between"}>
              <Flex justify={"space-between"}>{item.label}</Flex>
              <FeatherLeft width={14} />
            </div>
          ),
        }))}
      />
    </Flex>
  );

  return lg ? desktopMenu : mobileMenu;
};

export default ConnectionsMenu;
